'use strict';

var MarketIndicatorsAggregationFactory = function MarketIndicatorsAggregationFactory(AbstractROMServiceAggregationFactory) {
  function MarketIndicatorsAggregation() {
    AbstractROMServiceAggregationFactory.call(this, 'rom-analysis-skinny-services-mode', 'market-indicators');
  }
  MarketIndicatorsAggregation.prototype = Object.create(AbstractROMServiceAggregationFactory.prototype);
  MarketIndicatorsAggregation.constructor = MarketIndicatorsAggregation;
  MarketIndicatorsAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  MarketIndicatorsAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedMarketIndicatorsData = {};
    var actualSale = 0;
    var fcDemand = 0;
    var marketShareFcDemand;
    var marketShareFcDemandInd = 0;
    var marketShareFcDemandGroup = 0;
    var isIndividual = metricsKeys.indexOf('individual') > -1;
    var isGroup = metricsKeys.indexOf('group') > -1;
    for (var j = 0; j < data.length; j++) {
      var record = data[j];
      actualSale += this.getMetricValue(record.actualSale, metricsKeys);
      fcDemand += this.getMetricValue(record.fcDemand, metricsKeys);
      marketShareFcDemandInd += isIndividual ? record.fcDemand.individual * record.hostShare.individual : 0;
      marketShareFcDemandGroup += isGroup ? record.fcDemand.group * record.hostShare.group : 0;
    }
    marketShareFcDemand = marketShareFcDemandInd + marketShareFcDemandGroup;
    aggregatedMarketIndicatorsData.marketShare = marketShareFcDemand / fcDemand * 100;
    aggregatedMarketIndicatorsData.demandBookedRatio = fcDemand / actualSale;
    return aggregatedMarketIndicatorsData;
  };
  return MarketIndicatorsAggregation;
};
MarketIndicatorsAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory'];
module.exports = MarketIndicatorsAggregationFactory;